const COLORS = {
  default: '#D9D9D9',
  primary: '#4A90E2',
  secondary: '#FF4677',
  light: '#ffffff',
  dark: '#000000',
  success: '#27AE60',
  warning: '#FFA000',
  grey: '#838383',
};

export default COLORS;
